import { ItemType } from '@graphql/generated/graphql';
import { ItemIdentifierType } from 'src/types/programConfig';

/**
 * Map a program-configured identifier label to the GraphQL ItemType enum.
 *
 * Kept separate from `src/types/programConfig.ts` so type-only modules don't
 * pull in the generated GraphQL bundle, which would otherwise create a cycle
 * with the redux store initialization chain.
 */
export function toItemType(identifier: ItemIdentifierType): ItemType {
  switch (identifier) {
    case 'Scancode':
      return ItemType.Scancode;
    case 'ASIN':
      return ItemType.Asin;
    case 'SKU':
      return ItemType.Sku;
    default: {
      const exhaustive: never = identifier;
      throw new Error(`Unhandled identifier type: ${String(exhaustive)}`);
    }
  }
}
